var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 4,
    viewBox: "0 0 20 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20187 3.19922H18.8018C18.9594 3.19922 19.1155 3.16818 19.2611 3.10785C19.4067 3.04753 19.539 2.95912 19.6505 2.84766C19.7619 2.7362 19.8503 2.60388 19.9106 2.45826C19.9709 2.31263 20.0019 2.15656 20.0019 1.99894C20.0019 1.84134 19.9709 1.68527 19.9106 1.53965C19.8503 1.39404 19.7619 1.26173 19.6505 1.15029C19.539 1.03884 19.4067 0.950442 19.2611 0.890138C19.1155 0.829834 18.9594 0.798807 18.8018 0.798828H1.20187C0.885985 0.802523 0.584296 0.930599 0.36223 1.15528C0.140163 1.37996 0.015625 1.68312 0.015625 1.99903C0.015625 2.31493 0.140163 2.61809 0.36223 2.84277C0.584296 3.06745 0.885985 3.19553 1.20187 3.19922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus_icon.fc8281b430ace13b274fbdb242492e5e.svg";
export { ForwardRef as ReactComponent };